<template>
	<div class="table-row">
		<el-table
			:data="tableList"
			:header-cell-style="{ background: '#F0F1F5', color: '#4E596A', fontSize: '14px' }"
			row-class-name="table-row"
			style="width: 100%"
		>
			<el-table-column v-for="(item, index) in columns" :key="index" :label="item.label">
				<template v-slot="{ row }">
					<div v-if="item.template" class="font-h6-regular yx-color-text-primary">
						{{ row[item.prop] + '%' }}
					</div>
					<div v-else class="font-h6-regular yx-color-text-primary">
						{{ row[item.prop] }}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" v-if="type === 'activity_anchor'">
				<template v-slot="{ row }">
					<el-button type="text" class="fz-12" @click="del(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="温馨提示" :visible.sync="visible" :before-close="beforeClose" width="400px">
			<div class="yx-color-text-primary font-h4-regular">
				<i class=""></i>
				<span>确认是否要删除达人账号？</span>
			</div>
			<div slot="footer">
				<el-button @click="beforeClose">取消</el-button>
				<el-button type="primary" @click="confirmDel">确认删除</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { investmentAnchorKs } from '@/api/secondColonelManage';
export default {
	props: {
		tableList: {
			type: Array,
			default: () => [],
		},
		columns: {
			type: Array,
			default: () => [],
		},
		authorityId: {
			type: String,
			default: '',
		},
		thirdActivityId: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		beforeClose() {
			this.visible = false;
		},
		async confirmDel() {
			const { authorityId, thirdActivityId, anchorUids } = this;
			await investmentAnchorKs({
				platformId: +dataMap.PLATFORM_KS.value,
				anchorUids,
				operatorType: 2,
				authorityId,
				thirdActivityId,
			});
			this.$emit('refresh', 1);
			this.$message.success('操作成功');
			this.beforeClose();
		},
		async del(row) {
			this.anchorUids = [row.outer_anchor_id];
			this.visible = true;
		},
	},
};
</script>
<style lang='less' scoped>
/deep/ .el-table::before {
	background-color: transparent;
}
.table-row {
	border: 1px solid @border-color-extra-light;
	border-radius: 4px;
}
</style>